import React, { FC } from 'react';
import clsx from 'clsx';
import {
  Button,
  Modal as UIModal,
  Typography
} from '@npm-registry/eapteka-ui';
import { ModalProps } from '../types';
import styles from './Modal.scss';
import { text } from '../../../../text';

export const Modal: FC<ModalProps> = ({
  className,
  title = text['clearCart.title'],
  callback,
  onAccept
}) => {
  const rootClassNames = clsx([styles.root, className]);

  return (
    <UIModal visible={true} onClose={callback}>
      <div className={rootClassNames}>
        <header className={styles.header}>
          <Typography className={styles.title}>
            {title}
          </Typography>
        </header>
        <footer className={styles.footer}>
          <Button
            className={styles.button}
            type="button"
            variant="outlinedSolid"
            onClick={onAccept}
          >
            {text['clearCart.yes']}
          </Button>
          <Button
            className={styles.button}
            type="button"
            variant="filled"
            onClick={callback}
          >
            {text['clearCart.no']}
          </Button>
        </footer>
      </div>
    </UIModal>
  );
};
